import React, { useState, useEffect, useCallback } from 'react';
import { Col, Row } from 'reactstrap';
import __ from 'utils/i18n';
import { fetchResource } from 'api-provider';
import { confirmCampaign } from '../resources';
import { tenantId as staticTenantId } from 'config/envConfig';

export const ImportResults = ({
  data,
  token,
  subsidiaryId,
  onCampaignSubscribe,
  onCampaignConfirmed,
  onCampaignReset,
  fileName,
  onImportConfirmed,
  onCanImportChange,
  triggerImport,
  hideModal,
}) => {
  const [isFetching, setIsFetching] = useState(false);
  const [importOk, setImportOk] = useState(null);
  const [campaignId, setCampaignId] = useState(null);
  const [subscriptionSent, setSubscriptionSent] = useState(false);

  useEffect(() => {
    if (onCanImportChange) {
      const canImport = data?.totalProcessed > 0 && !isFetching && importOk === null;
      onCanImportChange(canImport);
    }
  }, [data, isFetching, importOk, onCanImportChange]);

  useEffect(() => {
    const resolvedId =
      data?.data?.campaignUuid ||
      data?.data?.campaign_id ||
      data?.campaignUuid ||
      data?.campaign_id ||
      null;

    setCampaignId(resolvedId);
    if (!resolvedId) {
      setSubscriptionSent(false);
    }
  }, [data]);

  useEffect(() => {
    if (
      campaignId &&
      typeof onCampaignSubscribe === 'function' &&
      !subscriptionSent
    ) {
      const totalRegisters = data?.successful || data?.totalProcessed || 0;
      onCampaignSubscribe({
        campaignUuid: campaignId,
        totalRegisters,
        fileName,
      });
      setSubscriptionSent(true);
    }
  }, [campaignId, subscriptionSent, onCampaignSubscribe, data, fileName]);

  const onImport = useCallback(() => {
    setIsFetching(true);
    const effectiveCampaignId =
      campaignId || data?.campaignUuid || data?.campaignId || data?.campaign_id;
    const name =
      fileName || `Massive Payment Links ${new Date().toISOString()}`;
    const totalRegisters = data?.successful || data?.totalProcessed || 0;
    const resolvedTenantId =
      subsidiaryId ||
      data?.data?.tenantId ||
      data?.data?.tenantIdentifier ||
      data?.data?.tenant_identifier ||
      data?.tenantId ||
      data?.tenant_id ||
      data?.tenantIdentifier ||
      data?.tenant_identifier ||
      staticTenantId ||
      null;

    const request = fetchResource(
      confirmCampaign(effectiveCampaignId, name, token),
    );
    request
      .onSuccess((responseData) => {
        setIsFetching(false);
        setImportOk(true);

        if (onImportConfirmed) onImportConfirmed();
        const confirmedUuid =
          responseData?.campaignUuid ||
          responseData?.campaign_id ||
          effectiveCampaignId;
        if (typeof onCampaignConfirmed === 'function') {
          onCampaignConfirmed({
            campaignUuid: confirmedUuid,
            totalRegisters,
            fileName,
            tenantId:
              responseData?.tenantId ||
              responseData?.tenantIdentifier ||
              responseData?.tenant_identifier ||
              resolvedTenantId,
          });
        }
      })
      .onFailure(() => {
        setIsFetching(false);
        setImportOk(false);
        setSubscriptionSent(false);
        if (typeof onCampaignReset === 'function') {
          onCampaignReset();
        }
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    campaignId,
    data,
    fileName,
    onCampaignConfirmed,
    onCampaignReset,
    onImportConfirmed,
    subsidiaryId,
    token,
  ]);

  useEffect(() => {
    if (triggerImport && !importOk && !isFetching) {
      onImport();
    }
  }, [triggerImport, importOk, isFetching, onImport]);

  useEffect(() => {
    if (!isFetching && importOk) {
      hideModal();
    }
  }, [isFetching, importOk, hideModal]);

  return (
    <div>
      {isFetching && (
        <div>
          {__('dashboard.sections.massivePaymentLink.import.upload.message.importing')}
        </div>
      )}

      {importOk === null && (
        <div className="import-results-container">
          <Row>
            <Col md='12'>
              {fileName && (
              <div className='import-results-container__file-name'>
                <span>Archivo:</span>
                <span>{fileName}</span>
              </div>
              )}
              <hr />
              {data?.totalProcessed ? (
                <div className="import-results-container__results">
                  <div className="block-content d-flex flex-column">
                    <span className="block-content-title">Total de registros:</span>
                    <span className="block-content-value text-body">{data.totalProcessed}</span>
                  </div>
                  <div className="block-content d-flex flex-column">
                    <span className="block-content-title">Correctos:</span>
                    <span className="block-content-value text-success">{data.successful}</span>
                  </div>
                  <div className="block-content d-flex flex-column">
                    <span className="block-content-title">Con error:</span>
                    <span className="block-content-value text-danger">{data.failed}</span>
                  </div>
                </div>
              ) : (
                <p>
                  {__(
                    'dashboard.sections.massivePaymentLink.import.upload.message.import_empty'
                  )}
                </p>
              )}
            </Col>
          </Row>
        </div>
      )}

    </div>
  );
};
